module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper order-info"
  }, [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("我的借款")])]), _vm._v(" "), _c('div', {
    staticClass: "subbar-wrap",
    class: {
      noTop: _vm.isWechat
    }
  }, [_c('div', {
    staticClass: "subbar-father"
  }, [_c('router-link', {
    key: 0,
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": '/user/order/' + _vm.orderNo + '/detail?isFbs=' + _vm.isFbs + '&isFI=' + _vm.isFI,
      "replace": ""
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('router-link', {
    key: 1,
    staticClass: "item",
    attrs: {
      "tag": "li",
      "to": '/user/order/' + _vm.orderNo + '/process?isFbs=' + _vm.isFbs + '&isFI=' + _vm.isFI,
      "replace": ""
    }
  }, [_vm._v("审批进程")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-content",
    class: {
      contentTop: _vm.isWechat
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7dc98e16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/order-info.vue
// module id = 369
// module chunks = 1